export default function HomeIcon({ width = 16, height = 16, fill = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.8169 7.55837C15.3974 7.13894 8.74938 0.490875 8.44189 0.18338C8.19787 -0.0607605 7.80212 -0.0607605 7.5581 0.18338C7.2218 0.519683 0.595581 7.14578 0.183105 7.55837C-0.0610351 7.80239 -0.0610351 8.19814 0.183105 8.44228C0.427124 8.6863 0.822875 8.6863 1.06689 8.44228L1.22913 8.28005V15.3753C1.22913 15.7205 1.50903 16.0003 1.85412 16.0003H14.1459C14.491 16.0003 14.7709 15.7205 14.7709 15.3753V8.28005L14.933 8.44228C15.1771 8.6863 15.5729 8.6863 15.8169 8.44228C16.061 8.19814 16.061 7.80239 15.8169 7.55837ZM9.83337 14.7503H6.16674V11.0836H9.83337V14.7503ZM13.5209 14.7503H11.0834V10.4586C11.0834 10.1134 10.8036 9.83364 10.4584 9.83364H5.54174C5.19653 9.83364 4.91674 10.1134 4.91674 10.4586V14.7503H2.47925V7.03005L7.99999 1.50918L13.5209 7.03005V14.7503Z" />
    </svg>
  );
}
